var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { SupportedMessageFormats } from "../../../Contracts";
const formats = {
    [SupportedMessageFormats["jsonrpc2.0"]]: ({ channel, data, meta, id }) => {
        return {
            jsonrpc: "2.0",
            params: data,
            method: channel,
            meta: {
                blockId: meta.requesterId
            },
            id
        };
    }
};
export function RequestFormatter(props) {
    const { type } = props, rest = __rest(props, ["type"]);
    return JSON.stringify(formats[type](rest));
}
//# sourceMappingURL=RequestFormatter.js.map